import { render } from "./DiceTwo.vue?vue&type=template&id=cf45c7f2"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/DiceTwo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf45c7f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf45c7f2', __exports__)) {
    api.reload('cf45c7f2', __exports__)
  }
  
  module.hot.accept("./DiceTwo.vue?vue&type=template&id=cf45c7f2", () => {
    api.rerender('cf45c7f2', render)
  })

}


export default __exports__